/* eslint-disable import/first */
import React, { useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector } = Redux;
import { FormattedMessage, useIntl } from 'react-intl';
const { selectCountryValidations, selectPaymentMethodConstants } = Slices.configSlice;
const { selectStoreEntities } = Slices.storeSlice;
const { selectCurrentCountry } = Slices.profileSlice;
const { selectProductEntities } = Slices.productSlice;
import { Paper, Grid, Typography, Divider, Link } from '@material-ui/core';
import { HiChevronDown } from '@react-icons/all-files/hi/HiChevronDown';
import { HiChevronUp } from '@react-icons/all-files/hi/HiChevronUp';
import css from './index.module.scss';
import CartValues from '../../containers/Cart/CartValues.jsx';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import OrderSummaryThankYou from '../OrderSummaryThankYou';
import supportPhone from './images/phonebtn.svg';
import UnableProcess from '../../components/UnableProcess';
import Writeus from '../../containers/ThankYou/Writeus';
import iconTile from './images/ic_summary.svg';
const OrderSummary = ({ orderInfo, ordStatus, enableState, paymentCompleted, isDesktop }) => {
  const [amountAccordState, setAmountAccordState] = useState(false);
  const country = useSelector(selectCurrentCountry);
  const intl = useIntl();
  const paymentMethodConst = useSelector(selectPaymentMethodConstants);
  const storeList = useSelector(selectStoreEntities);
  const [selectedStore, setSelectedStore] = React.useState({});
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const setAccordionStatus = () => {
    setAmountAccordState(!amountAccordState);
  };

  const productsMap = useSelector(selectProductEntities);

  const getAddressTypeText = (addressSubType) => {
    switch (addressSubType) {
      case 'PICKUP':
      case 'STORE':
        return <FormattedMessage id="order_pickUpAt" defaultMessage="Pickup Details" />;
      case 'CURBSIDE':
      case 'CARHOP':
        return <FormattedMessage id="order_curbSideAt" defaultMessage="Curbside Details" />;
      case 'DINEIN':
        return <FormattedMessage id="order_dineInAt" defaultMessage="Dine-in Details" />;
      case 'DELIVERY':
        return (
          <FormattedMessage id="orderstatus_delivaryaddress" defaultMessage="Delivery Address" />
        );
      default:
        return null;
    }
  };
  const addressSubType = orderInfo?.address?.addressSubType;
  const addressTypeText = getAddressTypeText(addressSubType);

  const filterMode = paymentMethodConst.filter((val) => val.name === orderInfo?.payment?.name);
  const groupMode = paymentMethodConst.filter(
    (val) => val.name === orderInfo?.payment?.paymentGroupCode
  );
  const sameMethod = orderInfo?.payment?.name === orderInfo?.payment?.paymentGroupCode;

  const addressString = `address_${intl.locale}`;
  const storeName = `name_${intl.locale}`;
  React.useEffect(() => {
    Object.values(storeList || {}).every((val) => {
      if (val.storeId === orderInfo?.store?.storeId) {
        setSelectedStore(val);
        return false;
      }
      return true;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderInfo]);
  if (!orderInfo) {
    return '';
  }

  const carDetail = orderInfo.dlvryInstr?.split(',')[0];

  const MessageBox = () => {
    let title = '';
    let content = '';
    if (ordStatus == 'FAILURE' || ordStatus == 'CANCELED') {
      title = '';
      content = (
        <p className={css.messageContent}>
          <FormattedMessage id={'refund_time'} />
        </p>
      );
    } else if (ordStatus == 'PENDING' && !enableState) {
      title = '';
      content = (
        <p className={css.messageContent}>
          <FormattedMessage
            id={'payment_initiate'}
            values={{
              price: decimalChecker(orderInfo?.payment?.amount),
              currency: countryValidations?.currency,
            }}
          />
        </p>
      );
    }

    return (
      <Grid className={css.messageBox}>
        <p className={css.messageTitle}>{title}</p>
        {content}
      </Grid>
    );
  };

  return (
    <Grid className={css.root}>
      <Grid className={css.title}>
        {!isDesktop && <img src={iconTile} alt="" />}
        <FormattedMessage id="orderstatus_ordersummary" defaultMessage="Order Summary" />
      </Grid>
      <Divider />
      {(!enableState && ordStatus === 'PENDING') ||
      ordStatus === 'FAILURE' ||
      ordStatus === 'CANCELED' ||
      paymentCompleted === false ? (
        <>
          <UnableProcess orderInfo={orderInfo} ordStatus={ordStatus} enableState={enableState} />
          <MessageBox />
          <Divider />
          <Writeus email={countryValidations?.supportEmail} />
        </>
      ) : (
        <Grid className={css.container}>
          <Grid className={css.DeliveryArea}>
            <span className={css.orderStoreTitle}>{addressTypeText}</span>
            {orderInfo?.address?.addressSubType !== 'DELIVERY' && (
              <>
                <div className={css.addressList}>
                  <div className={css.storeAddressArea}>
                    <div className={css.addressListItem}>
                      <div className={css.addressTitle}>
                        <div className={css.storeAddressText}>
                          {orderInfo?.address?.addressSubType === 'DINEIN' && (
                            <span className={css.orderStore}>
                              <span className={css.orderStoreDesc}>
                                <FormattedMessage
                                  id="order_dineInDesc"
                                  defaultMessage="Serving Order To"
                                />
                              </span>
                              {orderInfo?.dlvryInstr && (
                                <span className={css.orderStoreInfo}>
                                  <FormattedMessage id="table_no" defaultMessage="Table No." />{' '}
                                  {orderInfo?.dlvryInstr?.split(',')?.[0]?.trim()}
                                </span>
                              )}
                            </span>
                          )}
                          {(orderInfo?.address?.addressSubType === 'CURBSIDE' ||
                            orderInfo?.address?.addressSubType === 'CARHOP') && (
                            <span className={css.orderStore}>
                              <span className={css.orderStoreDesc}>
                                <FormattedMessage
                                  id="order_curbSideDesc"
                                  defaultMessage="Delivering order to your vehicle no."
                                />
                              </span>
                              {orderInfo?.dlvryInstr && (
                                <span className={css.orderStoreInfo}>
                                  {orderInfo?.dlvryInstr?.split(',')?.[0]?.trim()}
                                </span>
                              )}
                            </span>
                          )}
                          {orderInfo?.address?.addressSubType != 'DELIVERY' && (
                            <>
                              <div className={css.storeDetailsContainer}>
                                <div className={css.colBox}>
                                  <span className={css.storeAddress}>
                                    <FormattedMessage
                                      id="trackorder_storeaddress"
                                      defaultMessage="Store Address"
                                    />
                                  </span>
                                  <span className={css.storeName}>{selectedStore[storeName]}</span>
                                  <span className={css.addressDescription}>
                                    {selectedStore?.[addressString] || ''}
                                  </span>
                                </div>
                                <Grid className={css.iconContainer}>
                                  <Link href={`tel:${countryValidations?.customerCare}`}>
                                    <img src={supportPhone} alt="Support Contact No." />
                                  </Link>
                                </Grid>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
            {orderInfo?.address?.addressSubType === 'DELIVERY' && (
              <>
                <Typography className={css.addressDesc}>
                  {orderInfo?.address?.bldgName}, {orderInfo?.address?.flatNum}{' '}
                  {orderInfo?.address?.description}
                </Typography>
                {orderInfo?.address?.howToReach && (
                  <>
                    <span className={css.howToReachTitle}>
                      {intl.formatMessage({ id: 'nearestLandmark' })}
                    </span>
                    <span className={css.howToReachText}>{orderInfo?.address?.howToReach}</span>
                  </>
                )}
              </>
            )}
          </Grid>
          <Divider />
          <Grid className={css.paymentMode}>
            <Typography>
              <span className={css.paymentModeTitle}>
                <FormattedMessage id="orderstatus_paymentmode" defaultMessage="Payment Mode:" />{' '}
              </span>
              :
              {!sameMethod ? (
                <span className={css.paymentModeName}>{filterMode[0]?.value}</span>
              ) : (
                <span className={css.paymentModeName}>
                  {groupMode?.length ? groupMode[0]?.value : filterMode[0]?.value}
                </span>
              )}
            </Typography>
          </Grid>
          <Divider />
          <Grid className={css.orderItemContainer}>
            <Grid className={css.itemText}>
              <FormattedMessage id="orderstatus_items" defaultMessage="Items" />
            </Grid>
            <Grid>
              {orderInfo.items.map((item, i) => {
                const productInfo = productsMap[item?.id];
                return (
                  <Grid className={css.orderItems} key={i}>
                    <Grid className={css.nameArea}>
                      <Typography>{productInfo?.name || productInfo?.title || item.name}</Typography>
                    </Grid>
                    <Grid className={css.qtyArea}>
                      <Typography>{item.qty}</Typography>
                    </Grid>

                    <Grid className={css.price}>
                      <Typography>
                        {orderInfo?.promo?.freeItems?.indexOf(item.sku) > -1 ||
                        item?.price === 0 ? (
                          <>
                            {orderInfo?.promo?.couponType === 'discountItem' ? (
                              <>
                                {decimalChecker(item.price - orderInfo?.promo?.maxDiscountAmt)}{' '}
                                {countryValidations?.currency}
                              </>
                            ) : (
                              <FormattedMessage id="free" defaultMessage="free" />
                            )}
                          </>
                        ) : (
                          <>
                            {item?.price > 0 ? (
                              <>
                                {decimalChecker(item?.price)} {countryValidations?.currency}
                              </>
                            ) : (
                              ''
                            )}
                          </>
                        )}
                      </Typography>
                    </Grid>
                  </Grid>
                );
              })}
            </Grid>
          </Grid>
          <Divider />
          <Grid>
            <Grid className={css.accordion}>
              <Grid className={css.flexBox} onClick={setAccordionStatus}>
                <Typography>
                  <FormattedMessage id="orderstatus_grandtotal" defaultMessage="Grand Total" />{' '}
                </Typography>
                <Grid className={css.circle}>
                  {amountAccordState ? <HiChevronUp /> : <HiChevronDown />}
                </Grid>
              </Grid>
              <Typography>
                {decimalChecker(orderInfo?.payment?.amount)} {countryValidations?.currency}
              </Typography>
            </Grid>
            {amountAccordState && (
              <Grid>
                <CartValues amountObj={orderInfo.amount} currency={countryValidations?.currency} />
                {orderInfo?.vat?.amount && orderInfo?.vat?.amount !== '0' ? (
                  <OrderSummaryThankYou orderInfo={orderInfo} />
                ) : null}
              </Grid>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default OrderSummary;
